import {Fancybox} from '@fancyapps/ui';
// eslint-disable-next-line
import '@fancyapps/ui/dist/fancybox/fancybox.css';

const initFancyBox = (): void => {
    Fancybox.bind('[data-fancybox]', {});
};

export default initFancyBox;
